<div class="main-nav">
  <mat-nav-list>
    <!-- Inicio -->
    <a mat-list-item routerLink="/" routerLinkActive="active-menu-item" #rlaInicio="routerLinkActive"
      [activated]="rlaInicio.isActive" [matTooltip]="!expanded ? 'Inicio' : null" matTooltipPosition="right">
      <div class="menu-item">
        <mat-icon class="menu-icon">home</mat-icon>
        <span class="menu-text" *ngIf="expanded">Inicio</span>
      </div>
    </a>

    <!-- Items del menú -->
    <ng-container *ngFor="let item of menuItems">
      <!-- Sección Mis Hijos -->
      <ng-container *ngIf="item.nombre === 'Mis Hijos'; else otros">
        <ng-container *ngFor="let hijo of item.apps; trackBy: trackByHijo">
          <a mat-list-item (click)="toggleMenu(hijo)" [matTooltip]="!expanded ? hijo.nombre : null"
          [class.active-menu-item-2]="rlaInicio.isActive && isChildActive(hijo)"
            matTooltipPosition="right">
            <div class="menu-item">
              <mat-icon class="menu-icon">{{hijo.urlIcon || getIconForItem(hijo.nombre, true)}}</mat-icon>
              <span class="menu-text" *ngIf="expanded">{{hijo.nombre}}</span>
              <mat-icon class="expand-icon" *ngIf="expanded">
                {{hijo.menuShown ? 'expand_less' : 'expand_more'}}
              </mat-icon>
            </div>
          </a>

          <div *ngIf="hijo.menuShown" class="submenu">
            <ng-container *ngFor="let app of hijo.apps; trackBy: trackByApp">
              <ng-container *ngIf="!app.isExterno; else externo">
                <a mat-list-item [routerLink]="[app.url]" (click)="navigateAndClose()"
                  routerLinkActive="active-menu-item" #rlaApp="routerLinkActive" 
                  [activated]="rlaApp.isActive"
                  [matTooltip]="!expanded ? app.nombre : null" matTooltipPosition="right"
                  [queryParams]="getHijoQueryParams(hijo)">
                  <div class="menu-item submenu-item">
                    <mat-icon class="menu-icon-circle">{{app.urlIcon || getIconForItem(app.nombre, true)}}</mat-icon>
                    <span class="menu-text" *ngIf="expanded">{{app.nombre}}</span>
                  </div>
                </a>
              </ng-container>
              <ng-template #externo>
                <a mat-list-item href="{{app.url}}" target="_blank" (click)="handleExternalClick($event, hijo)"
                  [matTooltip]="!expanded ? app.nombre : null" matTooltipPosition="right">
                  <div class="menu-item submenu-item">
                    <mat-icon class="menu-icon-circle">{{app.urlIcon || getIconForItem(app.nombre, true)}}</mat-icon>
                    <span class="menu-text" *ngIf="expanded">{{app.nombre}}</span>
                    <mat-icon class="external-icon" *ngIf="expanded">open_in_new</mat-icon>
                  </div>
                </a>
              </ng-template>
            </ng-container>
            <mat-divider></mat-divider>
          </div>
        </ng-container>
      </ng-container>

      <!-- Otros items -->
      <ng-template #otros>
        <app-navmenu-dropdown *ngIf="item.apps.length > 0; else single" [item]="item" [expanded]="expanded"
          (toggle)="navigateAndClose()" (open)="handleDropdownOpen($event)"></app-navmenu-dropdown>
        <ng-template #single>
          <ng-container *ngIf="!item.isExterno; else externoSingle">
            <a mat-list-item [routerLink]="[item.url]" routerLinkActive="active-menu-item" #rlaItem="routerLinkActive"
              [activated]="rlaItem.isActive" [matTooltip]="!expanded ? item.nombre : null" matTooltipPosition="right">
              <div class="menu-item">
                <mat-icon class="menu-icon">{{item.urlIcon || getIconForItem(item.nombre)}}</mat-icon>
                <span class="menu-text" *ngIf="expanded">{{item.nombre}}</span>
              </div>
            </a>
          </ng-container>
          <ng-template #externoSingle>
            <a mat-list-item href="{{item.url}}" target="_blank" (click)="handleExternalClick($event)"
              [matTooltip]="!expanded ? item.nombre : null" matTooltipPosition="right">
              <div class="menu-item">
                <mat-icon class="menu-icon">{{item.urlIcon || getIconForItem(item.nombre)}}</mat-icon>
                <span class="menu-text" *ngIf="expanded">{{item.nombre}}</span>
                <mat-icon class="external-icon" *ngIf="expanded">open_in_new</mat-icon>
              </div>
            </a>
          </ng-template>
        </ng-template>
      </ng-template>
    </ng-container>
  </mat-nav-list>
</div>